import Select from 'react-select';
import React from 'react'
import { Button, Modal, ModalBody, CardBody, Media, Col, Form, Row, Label, Input, FormFeedback, FormGroup } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import { Password } from 'primereact/password';

export const ModalAuthorize = (props) => {
    const {
        modal, toggle, user_authorize, password_authorize, id_return_reason_woc, percentage_return,
        validationsCancelWorkOrder, totalCancellationWorkOrder, listDevolutions, loading,

        handleInputChangeCancelWorkOrder, handleValidateReturnAmount,
        saveCancelWorkOrderUpdate, aunthentication, validatePasswordCancell,
        errors
    } = props;

    const {
        user_authorize_valid,
        password_authorize_valid,
        id_return_reason_cancel_valid,
        percentage_return_cancel_valid
    } = validationsCancelWorkOrder;


    return (
        <Dialog
            visible={modal}
            onHide={toggle}
            closable={false}
            modal
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            maskClassName="custom-cancell-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-times-circle f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Cancelacion
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}

            className={`Global-dialog Global-dialog Global-blue Global-small-v `}

            footer={
                errors.length === 0 ? (
                    <div>
                        <Button
                            color="secondary text-center"
                            type="button"
                            onClick={validatePasswordCancell}
                        >
                            Autorizar
                        </Button>

                        <Button
                            color="danger text-center"
                            type="button"
                            onClick={toggle}
                        >
                            Cancelar
                        </Button>
                    </div>
                ) : (
                    <div>
                        <Button
                            color="danger text-center"
                            type="button"
                            onClick={toggle}
                        >
                            Cerrar
                        </Button>
                    </div>
                )
            }
        >


            {errors.length > 0 ? (

                <div className="validation-wrapper">

                    <div className="validation-header" style={{ marginBottom: "12px" }}>
                        <div
                            style={{
                                color: "#856404",
                                fontSize: "0.78rem",
                                marginTop: "6px",
                                fontWeight: "500",
                                backgroundColor: "#fff3cd",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                border: "1px solid #ffeeba",
                            }}
                        >
                            <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                            {"No se puede cancelar esta orden de trabajo" ?? "---"}
                        </div>
                    </div>
                    <div className="validation-box">
                        <ul className="validation-list">
                            {errors.map((error, index) => (
                                <li key={index} className="validation-item">
                                    <i className="pi pi-times-circle validation-icon"></i>
                                    {error}
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>
            ) : (

                <Form className="theme-form pr-0 pl-0 pt-2  " role="form">

                    <Row className="align-items-stretch">

                        <Col md="3" className="d-flex justify-content-center align-items-center ">
                            <div className="side-lock-wrapper">
                                <img
                                    src={require("../../assets/images/blog/password.svg")}
                                    alt="lock"
                                    className="side-lock-icon"
                                />
                            </div>
                        </Col>

                        <Col md="9" className='p-l-' >

                            <Row className="g-3 mb-3">
                                <Col md="5">
                                    <Label className="form-label-sm">Usuario</Label>
                                    <InputText
                                        name="user_authorize"
                                        value={user_authorize}
                                        onChange={handleInputChangeCancelWorkOrder}
                                        invalid={user_authorize_valid}
                                        className="w-100 custom-input"
                                    />
                                </Col>

                                <Col md="6">
                                    <Label className="form-label-sm">Contraseña</Label>
                                    <Password
                                        name="password_authorize"
                                        value={password_authorize}
                                        onChange={handleInputChangeCancelWorkOrder}
                                        feedback={false}
                                        toggleMask
                                        className="w-100"
                                    />
                                </Col>
                            </Row>



                            <Row className="mb-3">

                                <Col md="9">
                                    <Label className="form-label-sm">Motivo de devolución</Label>
                                    <Input
                                        type="select"
                                        name="id_return_reason_woc"
                                        value={id_return_reason_woc}
                                        invalid={id_return_reason_cancel_valid}
                                        onChange={handleInputChangeCancelWorkOrder}
                                        className="custom-input"
                                    >
                                        <option value={0}>Selecciona una opción</option>
                                        {listDevolutions.map((sg, key) => (
                                            <option value={sg.value} key={key}>
                                                {sg.label}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                                <Col md="3">
                                    <Label className="form-label-sm">Porcentaje</Label>
                                    <Input
                                        type="number"
                                        name="percentage_return"
                                        value={percentage_return}
                                        min={0}
                                        max={100}
                                        invalid={percentage_return_cancel_valid}
                                        onChange={handleValidateReturnAmount}
                                        className="custom-input"
                                    />
                                </Col>
                            </Row>

                            <Row className="align-items-end">


                                <Col md="8" className="text-end">
                                    <div className="refund-amount">
                                        La cantidad a devolver:
                                        <span className="refund-value">
                                            ${totalCancellationWorkOrder}
                                        </span>
                                    </div>
                                </Col>
                            </Row>

                        </Col>
                    </Row>

                </Form>

            )}




        </Dialog>
    )
}
